import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import styles from './styles';
import { CurrentWeather } from '../../components';

class Weather extends React.Component {
  render() {
    return (
      <React.Fragment>
        <CurrentWeather />
      </React.Fragment>
    );
  }
}

Weather.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

export default withStyles(styles)(withTranslation()(Weather));
